import { FC } from 'react';
import { SuperFormItemProps as SuperFormItemCopyProps } from './interface';
import DetailForm, { DetailFormProps } from './detailForm';
import TableForm, { TableFormProps } from './tableForm';

export type SuperFormItemProps = SuperFormItemCopyProps;
export type ISearchFormComponent = FC<DetailFormProps> & {
  TableForm: FC<TableFormProps>;
};
/** 快捷表单 */
const TransSuperForm = DetailForm as ISearchFormComponent;
TransSuperForm.TableForm = TableForm;

export default TransSuperForm;
